export const REGIONS = {
  europe: "Europe",
  americas: "Americas",
  china: "China",
  se_asia: "Southeast Asia",
};

export const DEFAULT_PAGE_SIZE = 25;
export const DATA_REFRESH_INTERVAL_MS = 30_000;
